const contractAddresses = {
  masterChef: "0xb00310683Ee98dca887e2e6AEfe6510F085802e1",
  multiCall: "0xb00310683Ee98dca887e2e6AEfe6510F085802e1",
  zap: "0xd88927A667e9883e101CEf509A8Da100F00c71fd",
  router: "0xCa4EAa32E7081b0c4Ba47e2bDF9B7163907Fe56f",
  factory: "0x591f122D1df761E616c13d265006fcbf4c6d6551",
  snow: "0x0370A6b59C312eB0E00EEc942496C0D5a6100DFC",
  weth: "0x4200000000000000000000000000000000000006",
  usdc: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
  nft: "0xb81026D460f254949a67FAAe48EC09073f020337",
  usdcLp: "0x6bee1580471F38000951abd788A9C060A4ad3Ac3",
  snowWethlp: "0x28eE0Ec1FcbeafB1F2F8d2558421d5e84Ab9fBe9",
  presaleContract: "0x4813B01898C3795783Cfa08FeE5aa040Ab029c86",
  presaleFork: "0x4813B01898C3795783Cfa08FeE5aa040Ab029c86",
};

export default contractAddresses;
